module.exports = __webpack_public_path__ + "static/media/shoe-XL.inline.670e07a4.svg";